import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../graphql/common.datatypes';
import {gqlPayment} from './getPayment.api';
import {Payment} from '../../graphql/payments.datatypes';

interface PaymentsData {
    paymentsInMyGroup: void,
    paymentsWithGroupMemberPaymentsOfType: void,
    payments: {
        data: Payment[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_PAYMENTS_QUERY = gql`
  query getPayments($count: Int!, $page: Int!, $where: WhereConditions, $hasBillingPartyMember: QueryPaymentsHasBillingPartyMemberWhereHasConditions, $orderBy: [OrderByClause!]){
    payments(first: $count, page: $page, where: $where, hasBillingPartyMember: $hasBillingPartyMember, orderBy: $orderBy){
      data {
        ${gqlPayment}
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getPayments = (count: number, page: number, where?: any, orderBy?: any, hasBillingPartyMember?: any) => useQuery<PaymentsData>(
    GET_PAYMENTS_QUERY,
    {
        variables: {
            count,
            page,
            where,
            hasBillingPartyMember,
            orderBy,
        },
    }
);

export default getPayments;
